import { Box } from "@mui/material";
import "leaflet/dist/leaflet.css";
import { Header } from "../../components/header/Header";
import "./styles/index.scss";
import GoogleMaps from "../../components/google-maps/GoogleMaps";

const MainScreen = () => {
  return (
    <>
      <Box className="main-screen-vacation">
        <GoogleMaps />
      </Box>
      <Box className="main-screen-header">
        <Header />
      </Box>
    </>
  );
};

export default MainScreen;
